import { useGetManyReference } from "react-admin";
import { SelectInput } from "./SelectInput";
import { Vehicle } from "../providers/vehiclesProvider";
import { useCurrentDrivingSchoolId } from "../hooks/useCurrentDrivingSchoolId";
import { l10n } from "../l10n";

export function VehicleInput(props: { source: string; label: string; size?: "small" }) {
  const { source, label, size } = props;
  const drivingSchoolId = useCurrentDrivingSchoolId();
  const { data: vehicles = [], isLoading } = useGetManyReference<Vehicle>("vehicles", {
    target: "drivingSchoolId",
    id: drivingSchoolId,
    filter: { deleted: false },
    sort: { field: "name", order: "ASC" },
    pagination: { page: 1, perPage: 999 },
  });

  return (
    <SelectInput
      source={source}
      label={label}
      optionsWithGroups={vehicles.map((v) => [v.id, v.name, l10n.vehicleTypePlural[v.type]])}
      groups={Object.values(l10n.vehicleTypePlural)}
      size={size}
      warning={!isLoading && vehicles.length === 0 ? "Es stehen keine Fahrzeuge zur Verfügung." : null}
    />
  );
}
